module.exports = __webpack_public_path__ + "static/img/30.2b188e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/30.png
// module id = tUNG
// module chunks = 1